import { OnInit, Component, ChangeDetectorRef, ViewChild } from '@angular/core';
import { filterPageTypes, toggleFilterTypes } from 'src/app/store/filters.era';
import { loadLocal } from '../../helpers/helpers';
import { Performer, tableFilterTypes } from 'src/app/store/performers.era';
import { programTableColumnsById } from 'src/app/helpers/table-helpers';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { JoiEvent } from 'globals/store/events.data';
import { programColumns, ProgramTableData } from 'src/app/helpers/table-column-types';
import { TableColumn } from 'src/app/helpers/table.data';
import { NestedTableComponent } from 'src/app/components/nested-table/nested-table.component';
import { Wrapper } from 'src/app/components/wrapper.component';
import { ManageProgramData, Program } from 'globals/store/programs.data';
import { ManageProgramComponent } from './../manage/manage-program.component';
import { saveTable } from '../performers/performerSharedFunctions';
import { programColumnsReselector, programTableReselector, programsArray } from '../../store/reselectors/programs.reselector';
import { CommonModule, DatePipe } from '@angular/common';
import { CommandMenuComponent } from 'src/app/components/nav-bar/command-menu.component';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { TopMenuComponent } from './top.menu';
import { MobileMenuComponent } from 'src/app/components/menu/mobile-menu.component';
import { traceNames } from 'src/app/services/performance.tracking.data';

@Component({
    selector: 'performer-sessions-table',
    template: `
<top-menu></top-menu>
<mobile-menu></mobile-menu>
<command-menu
  [filterPage]="filterPage"
  [filterType]="filterType"
  [filterText]="'Filter'"
  [columnType]="'programs'"
  [showDottedMenu]="true"
  [showExport]="true"
  [showImport]="false"
  [canEditColumns]="true"
  (onExport)="saveTable()"
></command-menu>
<nested-table
  [filtersId]="filterPage"
  [items]="tableRows || []"
  [readOnly]="true"
  [condensedView]="condensed"
  [columns]="columnData"
  [columnsById]="columnsById"
  [defaultSelectedColumnId]="defaultColumn"
  [emptyMessage]="'No room/locations in this event'"
  [noResultsMessage]="'No room/locations exist for the selected filters and/or search term'"
  [hadItemsBeforeFiltering]="!!programsList?.length"
  (selectItem)="manageProgram($event)"
></nested-table>
<loader-pane-fragment [trace]="traceNames.viewProgramTable" ></loader-pane-fragment>
`,
    styleUrls: ['../../page.scss'],
    standalone: true,
    providers: [DatePipe],
    imports: [CommonModule, CommandMenuComponent, NestedTableComponent, LoaderPaneFragmentComponent, TopMenuComponent, MobileMenuComponent],
})
export class ProgramTableComponent extends Wrapper<ProgramTableComponent> implements OnInit {
  filterPage = filterPageTypes.programTable
  filterType = tableFilterTypes.programTable
  defaultColumn = programColumns.name
  columnData: TableColumn[] = []
  columnsById: { [id: string]: TableColumn } = programTableColumnsById
  tableRows: ProgramTableData[]
  tableRowsById: { [id:string]: ProgramTableData } = {}
  condensed: boolean
  event: JoiEvent
  programsList: Program[]
  traceNames = traceNames
  

  @ViewChild(NestedTableComponent) nestedTable: NestedTableComponent<ProgramTableData>
  saveTable() {
    saveTable('room/locations' ,`${this.event.title} room/locations table.csv`, this.dialog, this.nestedTable)
  }
  
  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super()
    this.uiService.changePageTitle("Room/Locations", true)
    this.loadCondensed()
    this.subProp(this.store.select('events', 'event'), 'event')
    this.selectProp(programsArray, null, 'programsList')
    this.subCallback(this.store.select('filters', 'toggleFilters', this.filterPage, 'condensed'), _ => this.loadCondensed())
    this.subCallback(this.store.select(programTableReselector), data => {
      if (!data) {
        this.tableRows = [] // for when the last is deleted
        return
      }
      const { tableRows, tableRowsById } = data
      this.tableRows = tableRows
      this.tableRowsById = tableRowsById
    })
  }

  loadCondensed() {
    this.condensed = loadLocal(`${this.filterPage}:${toggleFilterTypes.condensed}`, false) 
    // console.log(this.condensed)
  }

  ngOnInit() {
    this.subProp(this.store.select(programColumnsReselector), 'columnData')
  }

  async manageProgram({ program }: ProgramTableData) {
    const data: ManageProgramData = { programId: program.id }
    this.changeDetectorRef.detach()
    await openDialogGetResult(this.dialog, ManageProgramComponent, { autoFocus: false, disableClose: true, data, panelClass: 'full-screen-modal' })
    this.changeDetectorRef.reattach()
  }

}
